const Constants = {
    SCHEDULED: 0,
    DEPARTED: 1,
    STAND_BY: 2,
    STAND_BY_COLOR: "#f44c0b",
    STAND_BY_COLOR_LIST: "#f44c0b85",
    DEPARTED_COLOR: "#fc2a2a",
    DEPARTED_COLOR_LIST: "#9d5f5d85",
    AVAILABLE: "* available *",
    AUTO_FILL_NONE: 0,		
		AUTO_FILL_DONE: 1,
		AUTO_FILL_DONE_VALIDATED: 8,
		AUTO_FILL_NOT_FOUND: 2,
		AUTO_FILL_POPUP_WARNING: 3,
		AUTO_FILL_ANOTHER_PLANE_WARNING: 4,    
		AUTO_FILL_POPUP_CONFIRMED: 5,
		AUTO_FILL_POPUP_REFUSED: 6,
		AUTO_FILL_CHANGED: 7
  };
  
export default Constants;